type Props = {
  children: React.ReactNode;
};

export function BlankLayout({ children }: Props) {
  return <main className="blank-layout">{children}</main>;
}
